import { api } from './Api';
import { CreateUserType, UserType } from '@/types/UserType';

// Removed unused interfaces: LoginRequest, ValidationRequest

interface LoginResponse {
  message: string;
  success: boolean;
}

interface ValidationResponse {
  message: string;
  success: boolean;
  data?: {
    user: any;
    access_token: string;
  };
}

async function login(email: string): Promise<LoginResponse> {
  return await api
    .post<LoginResponse>('/v1/authentication/login', { email })
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}

async function validation(
  email: string,
  code: string
): Promise<ValidationResponse> {
  return await api
    .post('/v1/authentication/validate-code', {
      email,
      code,
    })
    .then(res => {
      // Se a resposta já tem access_token diretamente, adapta para o formato esperado
      if (res.data.access_token && !res.data.success) {
        return {
          message: 'Validation successful',
          success: true,
          data: {
            access_token: res.data.access_token,
            user: res.data.user || {}, // user pode vir na resposta ou ser vazio
          },
        };
      }

      return res.data;
    })
    .catch(error => {
      throw error;
    });
}

async function register(user: CreateUserType): Promise<UserType> {
  return await api
    .post<UserType>('/v1/users', user)
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}

export const AuthService = {
  login,
  validation,
  register,
};
